import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData} from '../utils/endpoints'
import { Container, Row, Col } from 'react-bootstrap';
import Loading from './components/loading';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Header from './components/header';
import Footer from './components/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Sales from '../assets/svg/sales';
import Support from '../assets/svg/support';
import Media from '../assets/svg/media';
import { Helmet } from 'react-helmet';

const ContactUs = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>Shiva statue udaipur| tourist places near udaipur</title>
        </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
          <Container>
          <ul>
                <li><a href="/">Home</a></li>
                <li>Contact Us</li>
            </ul>
            <h1>Contact Us</h1>
          </Container>
        </section>
        <Container className='pt-5'>
        <div className='mapWrapper mb-5'>
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28946.756101221952!2d73.817235!3d24.920331!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39680d17f5546a41%3A0xa10522268d83a57e!2sVishwas%20Swaroopam%20(Statue%20of%20Belief)!5e0!3m2!1sen!2sin!4v1685170056383!5m2!1sen!2sin"  height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <Row>
          <Col lg={4} md={6} className='mb-lg-0 mb-4'>
            <div className='contactInner'>
              <span><Sales /></span>
              <h2>Sales</h2>
              <p><FontAwesomeIcon icon={faPhone} /><a href="tel:18001200351">+91-1800-120-0351</a></p>
              <p><FontAwesomeIcon icon={faPhone} /><a href="tel:918879953857">+91-8875-009-437</a></p>
              <p><FontAwesomeIcon icon={faEnvelope} /><a href="mailTo:nitin.ameta@statueofbelief.com">nitin.ameta@statueofbelief.com</a></p>
              <p><FontAwesomeIcon icon={faEnvelope} /><a href="mailTo:rakesh.jha@statueofbelief.com">mahesh.somani@statueofbelief.com</a></p>
            </div>
          </Col>
          <Col lg={4} md={6} className='mb-lg-0 mb-4'>
            <div className='contactInner'>
              <span><Support /></span>
              <h2>Help & Support</h2>
              <p><FontAwesomeIcon icon={faPhone} /><a href="tel:18001200351">+91-1800-120-0351</a></p>
              {/* <p><FontAwesomeIcon icon={faPhone} /><a href="tel:918879953857">+91-7877-190-351</a></p> */}
              <p><FontAwesomeIcon icon={faEnvelope} /><a href="mailTo:info.care@statueofbelief.com">care@statueofbelief.com</a></p>
            </div>
          </Col>
          <Col lg={4} md={6} className='mb-lg-0 mb-4'>
            <div className='contactInner'>
              <span><Media /></span>
              <h2>Media & Press</h2>
              <p><FontAwesomeIcon icon={faPhone} /><a href="tel:918879953857">+91-8875-009-437</a></p>
              <p><FontAwesomeIcon icon={faEnvelope} /><a href="mailTo:nitin.ameta@statueofbelief.com">nitin.ameta@statueofbelief.com</a></p>
            </div>
          </Col>
        </Row>
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default ContactUs;